import * as React from 'react';
export const handelsbankenSvg = React.forwardRef(function handelsbankenSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#005FA4',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M31.729 18.81c-.36.284-.952.515-2.445.747-1.338.231-2.444.566-2.444 2.058 0 1.261.978 1.647 1.673 1.647 1.595 0 3.216-1.029 3.216-2.701V18.81Zm.273 6.12c-.08-.305-.12-.567-.17-1.076-.824.849-1.982 1.981-4.426 1.981-2.058 0-4.168-1.157-4.168-3.988 0-2.676 1.698-4.04 3.988-4.374l3.242-.49c.566-.076 1.26-.308 1.26-1.08 0-1.518-1.44-1.595-2.367-1.595-1.8 0-2.11 1.106-2.212 1.904h-3.474c.412-4.194 3.32-4.786 6.124-4.786.624 0 1.416.062 2.2.26l.003 13.244ZM17.063 7v7H9.86V7H6v18.475h3.86V17.19h7.203v8.285h3.86V7h-3.86Z',
      fill: '#fff',
    }),
  );
});
handelsbankenSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var handelsbanken = {
  category: 'brand',
  colorable: false,
  name: 'handelsbanken',
  svg: handelsbankenSvg,
};
